<template>
  <br />
  <br />

  <div id="contenedor_principal" class="md:h-[790px] flex flex-col md:flex-row w-full items-stretch gap-4 relative">
    <div id="contenedor_izquierdo" class="md:h-[790px] flex-1 md:flex-[3] flex flex-col rounded-lg p-2">
      <!-- Tabs -->
      <div id="sub_contenedor_izq_superior"
        class="md:h-[60px] pt-0 flex flex-row justify-between rounded-lg p-0 gap-6 md:gap-8 font-bold text-md md:text-xl">
        <button
          v-for="(tab, index) in tabs"
          :key="tab.id"
          :class="getTabClasses(index)"
          @click="setActiveTab(index)"
        >
          {{ tab.label }}
        </button>
      </div>

      <div id="sub_contenedor_izq_inferior" class="md:h-[700px] justify-between rounded-lg pt-4">
        <div class="w-full flex flex-row justify-between md:mx-0">
          <!-- Mapa Santiago -->
          <div class="w-full relative contenido">
            <div class="md:block hidden transition-all">
              <img :src="'/img/home/nuevo_mapa.svg'" alt="" class="h-[700px] mx-auto" />

              <!-- Marcadores Santiago -->
              <div 
                v-for="ubicacion in ubicacionesSantiago"
                :key="ubicacion.id"
                :class="getMarkerClasses()"
                :style="{ top: ubicacion.coordinates.top, left: ubicacion.coordinates.left }"
                @click="selectLocation(ubicacion.id)"
              >
                <img :src="'/img/mapa/marca.webp'" alt="" />
                <div :class="getTooltipClasses(ubicacion.id)">
                  <div class="flex items-center gap-2">
                    <img :src="'/img/mapa/punt.webp'" alt="" class="h-5" />
                    <p v-html="ubicacion.direccion.replace('Poniente', '<br />Poniente')"></p>
                  </div>
                  <div class="flex items-center gap-2">
                    <img :src="'/img/mapa/tel.webp'" alt="" />
                    <a :href="`tel:${ubicacion.telefono.replace(/\s+/g, '')}`">{{ ubicacion.telefono }}</a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Versión móvil Santiago -->
            <div class="flex md:hidden flex-col gap-3">
              <div>
                <img :src="'/img/home/nuevo_mapa_mobile.svg'" alt="" />
              </div>

              <div>
                <Swiper v-if="swiperInit" id="swiper-carousel-free" class="pt-10" :modules="[SwiperPagination]" :loop="true"
                  :slides-per-view="1" :pagination="{
                    clickable: true,
                  }">
                  <SwiperSlide v-for="ubicacion in ubicacionesSantiago" :key="ubicacion.id" class="item flex">
                    <div class="flex flex-col items-center shadow-lg md:shadow-lg rounded-lg max-w-[300px] mx-auto">
                      <div class="uppercase font-bold border-b-2 border-ROJO_LEON w-full py-5">
                        <h2>{{ ubicacion.titulo }}</h2>
                      </div>
                      <div class="h-[250px] overflow-hidden">
                        <img :src="`/img/mapa/${ubicacion.img}`" alt="" class="w-[400px] h-[250px]" />
                      </div>
                      <div class="flex flex-col text-start w-full p-5">
                        <div class="flex items-center gap-2">
                          <img :src="'/img/mapa/punt.webp'" alt="" class="h-5 w-5 self-start" />
                          <p>{{ ubicacion.direccion }}</p>
                        </div>
                        <div class="flex items-center gap-2">
                          <img :src="'/img/mapa/tel.webp'" alt="" />
                          <a :href="`tel:${ubicacion.telefono.replace(/\s+/g, '')}`">{{ ubicacion.telefono }}</a>
                        </div>
                      </div>
                      <div>
                        <a :href="ubicacion.link"
                          class="bg-ROJO_LEON transition hover:bg-ROJO_FUERTE_LEON text-white py-3 px-5 rounded-lg flex items-center justify-center space-x-2 my-5 font-bold">
                          <span>Ver Local</span>
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                            fill="currentColor">
                            <path fill-rule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clip-rule="evenodd" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>

          <!-- Mapa Chile -->
          <div class="w-full relative contenido hidden">
            <div class="hidden md:block">
              <img :src="'/img/home/chile-desktop.webp'" alt="" class="h-[700px] mx-auto" />

              <!-- Marcadores Chile -->
              <div 
                v-for="ubicacion in ubicacionesChile"
                :key="ubicacion.id"
                :class="getMarkerClasses()"
                :style="{ top: ubicacion.coordinates.top, left: ubicacion.coordinates.left }"
                @click="selectLocation(ubicacion.id)"
              >
                <img :src="'/img/mapa/marca.webp'" alt="" />
                <div :class="getTooltipClasses(ubicacion.id)">
                  <div class="flex items-center gap-2">
                    <img :src="'/img/mapa/punt.webp'" alt="" class="h-5" />
                    <p>{{ ubicacion.direccion }}</p>
                  </div>
                  <div class="flex items-center gap-2">
                    <img :src="'/img/mapa/tel.webp'" alt="" />
                    <a :href="`tel:${ubicacion.telefono.replace(/\s+/g, '')}`">{{ ubicacion.telefono }}</a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Versión móvil Chile -->
            <div class="flex md:hidden flex-col gap-3">
              <div>
                <img :src="'/img/home/chile-mobile.webp'" alt="" class="max-h-[600px] mx-auto" />
              </div>

              <div>
                <Swiper v-if="swiperInit" id="swiper-carousel-free" class="mt-10" :modules="[SwiperPagination]" :loop="true"
                  :slides-per-view="1" :pagination="{
                    clickable: true,
                  }">
                  <SwiperSlide v-for="ubicacion in ubicacionesChile" :key="ubicacion.id" class="item my-5 flex">
                    <div class="flex flex-col items-center shadow-lg rounded-lg max-w-[300px] mx-auto">
                      <div class="uppercase font-bold border-b-2 border-ROJO_LEON w-full py-5">
                        <h2>{{ ubicacion.titulo }}</h2>
                      </div>
                      <div class="h-[250px] overflow-hidden">
                        <img :src="`/img/mapa/${ubicacion.img}`" alt="" class="w-[400px] h-[250px]" />
                      </div>
                      <div class="flex flex-col text-start w-full p-5">
                        <div class="flex items-center gap-2">
                          <img :src="'/img/mapa/punt.webp'" alt="" class="h-5 w-5 self-start" />
                          <p>{{ ubicacion.direccion }}</p>
                        </div>
                        <div class="flex items-center gap-2">
                          <img :src="'/img/mapa/tel.webp'" alt="" class="h-5 w-5 self-start" />
                          <a :href="`tel:${ubicacion.telefono.replace(/\s+/g, '')}`">{{ ubicacion.telefono }}</a>
                        </div>
                      </div>
                      <div>
                        <a :href="ubicacion.link"
                          class="bg-ROJO_LEON transition hover:bg-ROJO_FUERTE_LEON text-white py-3 px-5 rounded-lg flex items-center justify-center space-x-2 my-5 font-bold">
                          <span>Ver Local</span>
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                            fill="currentColor">
                            <path fill-rule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clip-rule="evenodd" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Panel derecho -->
    <div id="contenedor_derecho" class="h-[790px] flex-1 md:flex-[2] md:block info-container rounded-lg p-0 hidden">
      <div v-if="selectedLocation" class="flex flex-col items-center shadow-2xl rounded-lg max-w-[400px] h-[790px] mx-auto">
        <div class="uppercase font-bold text-2xl border-b-2 border-ROJO_LEON w-full py-5 text-center">
          <h2>{{ selectedLocation.titulo }}</h2>
        </div>
        <div class="h-[250px] overflow-hidden w-full">
          <img :src="`/img/mapa/${selectedLocation.img}`" :alt="selectedLocation.titulo" class="w-[400px] h-[250px]" loading="lazy" decoding="async">
        </div>
        <div class="flex flex-col text-start w-full p-5">
          <div class="flex items-center gap-2">
            <img src="/img/mapa/punt.webp" alt="" class="">
            <p>{{ selectedLocation.direccion }}</p>
          </div>
          <div class="flex items-center gap-2">  
            <img src="/img/mapa/tel.webp" alt="" class="">
            <a :href="`tel:${selectedLocation.telefono.replace(/\s+/g, '')}`">{{ selectedLocation.telefono }}</a>
          </div>
        </div>
        <div class="w-full">
          <iframe :src="selectedLocation.mapa" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" width="100%" height="250px"></iframe>
        </div>
        <div>
          <a :href="selectedLocation.link" class="bg-ROJO_LEON transition hover:bg-ROJO_FUERTE_LEON text-white py-3 px-5 rounded-lg flex items-center justify-center space-x-2 my-5 font-bold">
            <span>Ver Local</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
      <div v-else class="w-full h-full md:block info-container">
        <img src="/img/mapa/banner-mapas-webp.webp" alt="" class="h-full w-full mx-auto object-cover" loading="lazy" decoding="async" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination as SwiperPagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import { useTabsMap } from '@/composables/useTabsMap'

const isSmallScreen = ref(false)
const swiperInit = ref(false)

const {
  selectedLocation,
  tabs,
  ubicacionesSantiago,
  ubicacionesChile,
  setActiveTab,
  selectLocation,
  getTabClasses,
  getMarkerClasses,
  getTooltipClasses
} = useTabsMap()

const handleResize = () => {
  isSmallScreen.value = window.innerWidth <= 768
}

const addEventListenerWindow = async () => {
  window.addEventListener("resize", handleResize)
}

const removeEventListenerWindow = async () => {
  window.removeEventListener("resize", handleResize)
}

onMounted(async () => {
  await addEventListenerWindow()
  handleResize()
  swiperInit.value = true
})

onBeforeUnmount(async () => {
  await removeEventListenerWindow()
})
</script>